function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    document.querySelector('.header').classList.add('submenu-open');
    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');

    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {

    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');

        details.classList.remove('menu-opening');
      });
      document.querySelector('.header').classList.remove('submenu-open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
    });
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.querySelector('.template-popup')?.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    button?.addEventListener('click', () => {
      document.querySelector(this.getAttribute('data-modal'))?.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      window.pauseAllMedia();
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

$(document).ready(function () {
  $('.js-animate-on-load').addClass('animate-in');

  let isTabletUp;

  function checkForBreakpoint () {
    if ($(window).innerWidth >= 750) {
      isTabletUp = true;
    } else {
      isTabletUp = false;
    }
  }

  checkForBreakpoint();

  $(window).on('resize', function () {
    checkForBreakpoint();
  });

  const swiper = new Swiper('.swiper-reviews', {
    direction: 'horizontal',
    slidesPerView: 1.15,

    spaceBetween: 0,
    grabCursor: true,
    freeMode: false,
    loop: false,
    mousewheel: {
      forceToAxis: true
    },
    scrollbar: {
      el: '.swiper-scrollbar',
    },
    breakpoints: {
      750: {
        slidesPerView: 3,
      }
    },
  });

  $('.js-grandchild-link').on('mouseenter', function () {
    if ($(window).innerWidth() > 990) {
      var imageToShow = $(this).attr('data-collection-image');
      if (imageToShow != undefined && imageToShow.length > 0) {
        var linkText = $(this).find('.link-text').text();
        $('.header__collection-preview .media').html('<img src="' + imageToShow + '" alt="" width="200" />');
        $('.header__collection-preview .desc').html(linkText);
      }
    }
  });

  $('.js-grandchild-link').on('mouseleave', function () {
    $('.header__collection-preview .media').html('');
    $('.header__collection-preview .desc').html('');
  });




  /* ---------------------------------------------
  PDP SLIDERS
  ------------------------------------------------ */
  $('.page-product #MainContent').on('click', 'a', function (e) {
    var flyoutToShow = $(this).attr('href');
    if (flyoutToShow.substring(0, 1) == '#') {
      e.preventDefault();
      var targetId = flyoutToShow.split('#')[1];
      $('body').addClass('open-pdp-flyout');
      $('#' + targetId).addClass('active-flyout');
    }
  });

  $('.close-pdp-flyout').on('click', function () {
    $('body').removeClass('open-pdp-flyout');
    $('.active-flyout').removeClass('active-flyout');
  });



  /* ---------------------------------------------
  COOKIES
  ------------------------------------------------ */
  // GET COOKIE -------------
  function getCookie(name) {
    const dc = document.cookie;
    const prefix = `${name}=`;
    let begin = dc.indexOf(`; ${prefix}`);
    if (begin == -1) {
      begin = dc.indexOf(prefix);
      if (begin != 0) return null;
    } else {
      begin += 2;
      var end = document.cookie.indexOf(';', begin);
      if (end == -1) {
        end = dc.length;
      }
    }

    return decodeURI(dc.substring(begin + prefix.length, end));
  }

  // SET COOKIE -------------
  function setCookie (cookieName) {
    const date = new Date();
    const days = 30;

    // Get unix milliseconds at current time plus number of days
    date.setTime(+date + days * 86400000); // 24 * 30 * 60 * 1000
    window.document.cookie = `${cookieName +
      '=' +
      'no' +
      '; expires='}${date.toGMTString()}; path=/`;
  }

  /* ---------------------------------------------
  EMAIL POPUP
  ------------------------------------------------ */
  // Get cookies on load;
  const hasVisited = getCookie('newsletter-popup-dismissed');

  // if (true) {
  if (hasVisited === null) {
    setTimeout(function () {

      $('body').addClass('show-email-popup');
      $('.email-popup-form-wrapper').focus();
      $('.newsletter-popup').addClass('animate-in');
    }, 10000);
  } else {
    $('.newsletter-popup').remove();
  }


  // KLAVIYO FORM START ------
  function validateEmail (email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  function closePopup () {

  }

  // SUCCESS =========================
  function formSubmitted ($form) {
    // SHOW SUCCESS MESSAGE
    $form.find('.js-inner-form-wrap').hide();
    $form.find('.success-message').fadeIn();


    // DON'T SHOW AGAIN
    setCookie('newsletter-popup-dismissed');

    // Briefly show success message, then hide popup
    setTimeout(function () {
      $('body').removeClass('show-email-popup email-submitted');
    }, 3000);
  }

  // FORM SUBMIT =========================
  $('.js-klaviyo-form').on('submit', function (e) {
    e.preventDefault();
    var $form = $(this);
  	var email = $(this).find("input[type=email]").val();

    // CHECK FOR VALID EMAIL ADDRESS
    if (validateEmail(email)) {
      $($form).find('.error-message').fadeOut();

      var listId = $form.data('list-id');

      $.ajax({
        url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
        method: "POST",
        crossDomain: true,
        dataType: 'json',
        data: {
          "g": listId,
          '$consent': 'web',
          'email': email,
        },
        success: function (data) {
          formSubmitted($form);
        }
      });
    } else {
      $($form).find('.error-message').fadeIn();
    }
  });

  $('.js-close-email-popup').on('click', function () {
    // DON'T SHOW AGAIN
    setCookie('newsletter-popup-dismissed');
    $('body').removeClass('show-email-popup');
  });

  $('.js-open-blog-cat-flyout').on('click', function (e) {
    e.preventDefault();
    const headerBottom = $('.header-wrapper').offset().top + $('.header-wrapper').innerHeight() - 1;
    const paddingTop = headerBottom + 12;
    $('.main-blog__nav-flyout').css('padding-top', paddingTop + 'px');
    $('.main-blog__nav-flyout, .main-blog__nav-bg').addClass('open-flyout');
    $('.main-blog__nav-flyout').focus();
  });

  $('.js-close-blog-cat-flyout').on('click', function (e) {
    e.preventDefault();
    $('.main-blog__nav-flyout, .main-blog__nav-bg').removeClass('open-flyout');
  });

  $('.header summary.header__menu-item').on('click', function () {
    if ($(this).closest('details').attr('open')) {
      $('.header').removeClass('submenu-open');
    } else {
      $('.header').addClass('submenu-open');
    }
  });

  $('.js-close-nav-dropdown').on('click', function () {
    $('.header').removeClass('submenu-open');
    $('.header details').prop('open', false);
    $('.overflow-hidden-tablet').removeClass('overflow-hidden-tablet');
  });

  $('.header__heading-link').on('mouseenter', function () {
    $('.header details').prop('open', false);
  });

  $('.menu-drawer__menu-item-grandchild').on('click', function () {
    var hrefAttr = $(this).attr('href');
    if (hrefAttr.includes('#')) {
      $('.header details').prop('open', false);
      $('.overflow-hidden-tablet').removeClass('overflow-hidden-tablet');
      $('.header').removeClass('submenu-open');
    }

  })

  $('.list-menu--inline .header__menu-item').on('click', function (e) {
    if ($(window).innerWidth() > 750) {
      e.preventDefault();
      window.location.href = $(this).data('link');
    }
  });

  $('summary.header__menu-item').on('mouseenter', function (e) {
    $('details').prop('open', false);
    $(this).closest('details').prop('open', true);
  });

  $('.header').on('mouseleave', function (e) {
    $('.header details').prop('open', false);
  });

  /* ---------------------------------------------
  SMOOTH SCROLL
  ------------------------------------------------ */
  $('.js-scroll-to').on('click', function(e) {
    e.preventDefault();

    var thisTarget = $(this).attr('href');

    if (thisTarget == '#bottom') {
      var targetOffset = $('#top').offset().top + $('#top').outerHeight() - $(window).height();
    } else {
      var targetOffset = $(thisTarget).offset().top;
    }

    $('html, body').animate({
      scrollTop: targetOffset
    }, 600);
  });

  $(window).on('scroll', function () {
    if (isTabletUp) return;
    if ($(window).scrollTop() > 300) {
      $('.jump-top-link').fadeIn();
    } else {
      $('.jump-top-link').fadeOut();
    }
  });

  /* ---------------------------------------------
    CUSTOM PARALLAX & SCROLLING ZOOM EFFECTS
  ------------------------------------------------ */
  gsap.registerPlugin(ScrollTrigger);

  // Set Defaults for ScrollTrigger (like showing markers for debugging)
  ScrollTrigger.defaults({
    markers: false,
  });


/* ---------------------------------------------
  HOME - PIN PANELS
------------------------------------------------ */
if ($('.js-pin-panel-wrap').length > 0) {
  gsap.set($('.js-pin-panel-wrap:not(:first)'), { autoAlpha: 0 });

  var pinnedSections = gsap.utils.toArray('.js-pin-panel-wrap');

  var totalDuration = 1400 * pinnedSections.length;
  var singleDuration = totalDuration / pinnedSections.length;

  pinnedSections.forEach((elem, i) => {
    const first = i == 0;
    const last = i == pinnedSections.length - 1;
    let pinnedSplitTextLines;
    let pinnedSplitLineChild;

    ScrollTrigger.create({
      trigger: '.js-pinned-sections',
      start: 'top -=' + ( singleDuration * i ),
      end: '+=' + singleDuration,

      // markers: false,
      onEnter: () => {

        gsap.to(elem, .6, { autoAlpha: 1, y: 0 }, 0);
        gsap.fromTo($(elem).find('.animate-up'), 1.2, {autoAlpha: 0, x: 40}, {autoAlpha: 1, x: 0, ease:Power4.easeOut, delay: .2});

        let pinTl = gsap.timeline();

        // ANIMATE TEXT UP AND IN
        pinTl.staggerFromTo($(elem).find('.pin-animate'), 1, {y: 40, autoAlpha: 0}, {y: 0, autoAlpha: 1, ease: Power3.easeOut}, 0.15);

        $('.active-counter').removeClass('active-counter');
        $(`.js-pinned-sections [data-counter-index="${i}"]`).addClass('active-counter');

      },
      onEnterBack: () => {
        gsap.to(elem, .6, { autoAlpha: 1, y: 0 }, 0);
        gsap.fromTo($(elem).find('.animate-up'), 1.4, {autoAlpha: 0, x: -40}, {autoAlpha: 1, x: 0, ease:Power4.easeOut, delay: 0});
        $('.active-counter').removeClass('active-counter');
        $(`.js-pinned-sections [data-counter-index="${i}"]`).addClass('active-counter');

        let pinTl = gsap.timeline();

        // ANIMATE TEXT DOWN AND IN
        pinTl.staggerFromTo($(elem).find('.pin-animate'), 1.2, {y: 40, autoAlpha: 0}, {y: 0, autoAlpha: 1, ease: Power3.easeOut}, -0.15);

      },
      onLeave: () => {
        gsap.fromTo($(elem).find('.animate-up'), 1.2, {autoAlpha: 1, x: 0}, {autoAlpha: 0, x: -40, ease:Power4.easeOut, delay: .2});
        let pinTl = gsap.timeline();
          pinTl.staggerFromTo($(elem).find('.pin-animate'), 1, {y: 0, autoAlpha: 1}, { y: '-50%', autoAlpha: 0, ease: Power3.easeOut}, 0.05);
          if (!last) {
            gsap.to(elem, .6, { autoAlpha: 0, y: 0 }, 0);
          }
      },
      onLeaveBack: () => {
        // ANIMATE TEXT DOWN AND OUT
        gsap.fromTo($(elem).find('.animate-up'), 1.2, {autoAlpha: 1, x: 0}, {autoAlpha: 0, x: 40, ease:Power4.easeOut, delay: .35});
        let pinTl = gsap.timeline();
        pinTl.staggerFromTo($(elem).find('.pin-animate'), 1, {y: 0, autoAlpha: 1}, { y: '50%', autoAlpha: 0, ease: Power3.easeOut}, 0.05);
        if (!first) {
          gsap.to(elem, .6, { autoAlpha: 0, y: 0 }, 0);
        }
      }
    });

  });

  ScrollTrigger.create({
    trigger: '.js-pinned-sections',
    start: 'top top',
    end: '+=' + totalDuration,
    markers: false,
    pin: true,
    pinSpacing: true,
    scrub: true,
  });

}

/* ---------------------------------------------
  ADD CLASS ON ENTRY
------------------------------------------------ */
gsap.utils.toArray('.js-animate').forEach((elem, i) => {
  ScrollTrigger.create({
    trigger: elem,
    start: 'top 80%',
    onEnter: self => $(elem).addClass('animate-in')
  });
});

/* ---------------------------------------------
  STAGGER / BATCH ANIMATION
------------------------------------------------ */
// Opacity set to 0 in CSS on load to avoid FOUC
ScrollTrigger.batch('[data-stagger]', {
  onEnter: batch => gsap.to(batch, .8, {autoAlpha: 1, y: 0, stagger: 0.08, ease:Power1.easeOut}),
  start: "40px bottom",
});

/* ---------------------------------------------
  SPLIT TEXT
------------------------------------------------ */
// Text animation helper function
function triggerTextAnimation (delay, start, elem, resetAfter) {
  var tl = gsap.timeline({
    scrollTrigger: {
      trigger: elem,
      start: start
    }
  });

  const splitLineChild = new SplitText(elem, { type: "lines", linesClass: "split-line-child" });
  const splitTextLines = new SplitText(elem, { type: "lines", linesClass: "split-line-wrap-++" });

  tl.staggerFrom($(elem).find('.split-line-child'), 1.2, {y: '100%', ease: Power3.easeOut, delay: delay}, 0.15)
  .add( function () {
    if (resetAfter != "false") {
      splitTextLines.revert();
      splitLineChild.revert();
    } else {
      $(elem).addClass('visible-innards');
    }
  });
}



ScrollTrigger.refresh();

document.fonts.ready.then(function () {
  $('[data-reveal="lines-masked"]').addClass('loaded');
  $('[data-reveal="lines-masked-desc"]').addClass('loaded');
  $('[data-reveal="words-masked"]').addClass('loaded');

  // REGULAR TEXT ANIMATION
  gsap.utils.toArray('[data-reveal="lines-masked"]').forEach((elem, i) => {
    const delay = elem.dataset.delay ? elem.dataset.delay : 0;
    const start = elem.dataset.start ? elem.dataset.start : "center bottom";
    const resetAfter = elem.dataset.reset ? elem.dataset.reset : "true";
    triggerTextAnimation(delay, start, elem, resetAfter);
  });

  gsap.utils.toArray('[data-reveal="lines-masked-desc"]').forEach((elem, i) => {
    const delay = elem.dataset.delay ? elem.dataset.delay : 0;
    const start = elem.dataset.start ? elem.dataset.start : "center bottom";
    const resetAfter = elem.dataset.reset ? elem.dataset.reset : "true";
    triggerTextAnimation(delay, start, $(elem).find('p'), resetAfter);
  });

  gsap.utils.toArray('[data-reveal="pinned-lines"] p').forEach((elem, i) => {
    const splitLineChild = new SplitText(elem, { type: "lines", linesClass: "pin-animate" });
  });

  gsap.utils.toArray('[data-reveal="lines-masked-sideways"] p').forEach((elem, i) => {
    const splitLineChild = new SplitText(elem, { type: "lines", linesClass: "animate-from-side" });

    var hexagon = $(elem).find('.animate-from-side').toArray();
    hexagon.sort(function() { return 0.5-Math.random()} );

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: elem,
        start: "center bottom"
      }
    });

    tl.staggerFromTo(hexagon, 1, {x: -40, rotation:0.001, autoAlpha: 0}, { x: 0, rotation:0.001, autoAlpha: 1, ease: Power1.easeOut}, 0.06)
    .add( function () {
      $(elem).addClass('visible-innards');
    });
  });

  $('[data-reveal="lines-masked-sideways"]').addClass('loaded');

  // WORDS POPPING UP FROM TILTED MASKS
  gsap.utils.toArray('[data-reveal="words-masked"]').forEach((elem, i) => {
    const start = elem.dataset.start ? elem.dataset.start : "top 80%";

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: elem,
        start: start
      }
    });

    var splitText = new SplitText($(elem).find('.animate-me'), { type: "lines,words", linesClass: "split-line-wrap", wordsClass: "split-line-child" });

    tl.staggerFrom($(elem).find('.split-line-child'), 1.4, {y: '100%', skewX: -15, rotate: 2, ease: Power4.easeOut}, .1);

    $(window).resize(function () {
      tl.progress(1);
      splitText.revert();
    });
  });

  // WORDS SLIDING UP IN BLOCKS
  gsap.utils.toArray('[data-reveal="blocks-slide"]').forEach((elem, i) => {
    const start = elem.dataset.start ? elem.dataset.start : "top 80%";

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: elem,
        start: start
      }
    });

    tl.staggerFrom($(elem).find('.animate-me'), 1.4, {y: '200px', autoAlpha: 0, ease: Power4.easeOut}, .1);
  });
});

$( window ).on("load", function() {
  $('.js-lazy-video source').each(function () {
    var sourceFile = $(this).attr('data-src');
    $(this).attr('src', sourceFile);
    var video = this.parentElement;
    video.load();
    video.play();
  });

  $('.js-lazy-video--vimeo').each(function () {
    var sourceFile = $(this).attr('data-src');
    $(this).attr('src', sourceFile);
  });

});

/*=========================
VIMEO VIDEOS
===========================*/
if ($('.js-autoplay-vimeo').length > 0) {
  $('.js-autoplay-vimeo').each(function () {
    $(this).attr('src', $(this).attr('data-src'));
    var iframe = this;
    var player = new Vimeo.Player(iframe);
    var isPlayingMobile = false;

    if ($(window).innerWidth() <= 750) {
      player.setQuality('540p').then(function(quality) {
        player.play();
        player.on('playing', function(data) {
          isPlayingMobile = true;
        });
        $('body').one('click touchstart', function () {
            player.play();
        });
      }).catch(function(error) {
        switch (error.name) {
          case 'TypeError':
            break;

          default:
            break;
        }
      });
    } else {
      player.play();
    }
  });

}

// Creates a new IntersectionObserver to track when autoplay items get into viewport
const vimeoAutoplayObserver = new IntersectionObserver(function (entries, observer) {
  entries.forEach((entry) => {
    // Gets our iframe
    const iframe = $(entry.target);

    // Toggles play/pause as needed
    if (entry.isIntersecting) {
      // Adjusts frame source as needed
      if (iframe.attr('data-src') == '') {
        iframe.attr('data-src', iframe.attr('data-org-src'));
        iframe.attr('src', iframe.attr('data-src'));
      }

      // Gets the Vimeo player instance
      const player = new Vimeo.Player(entry.target);

      // Plays video
      player.play();
    } else {
      // // Gets the Vimeo player instance
      // const player = new Vimeo.Player(entry.target);

      // // Pauses video
      // player.pause();
    }
  });
}, {
  // This will make the player register as "observed" when it's half a viewport away from entering our viewport
  rootMargin: '100% 0px',
  threshold: 0,
});

// Binds our Observer into the Vimeo autoplay entries
$('.js-vimeo-play-on-visible').each((i, o) => {
  vimeoAutoplayObserver.observe(o);
});

$.fn.isOnScreen = function(){
    
  var win = $(window);
  
  var viewport = {
      top : win.scrollTop(),
      left : win.scrollLeft()
  };
  viewport.right = viewport.left + win.width();
  viewport.bottom = viewport.top + win.height();
  
  var bounds = this.offset();
  bounds.right = bounds.left + this.outerWidth();
  bounds.bottom = bounds.top + this.outerHeight();
  
  return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
  
};

$('.js-product-card').on('mouseenter', function () {
  if ($(window).innerWidth() >= 990) {
    $('.js-hover-video').html('');
    var videoWrapper = $(this).find('.js-hover-video');
    var videoSrc = videoWrapper.attr('data-src');

    const videoElement = `<video autoplay muted loop poster="">
                           <source src="${videoSrc}" type="video/mp4">
                          </video>`

    videoWrapper.html(videoElement);
  }
});

$('.js-product-card').on('mouseleave', function () {
  $('.js-hover-video').html('');
});




/* ---------------------------------------------
  HOME - SCROLL ENTER EVENTS
------------------------------------------------ */
/*** Different ScrollTrigger setups for various screen sizes (media queries) ***/
ScrollTrigger.matchMedia({
  // desktop
  "(min-width: 1024px)": function() {
    gsap.utils.toArray('[data-from]').forEach((elem, i) => {
      const from = JSON.parse(elem.dataset.from);
      const to = JSON.parse(elem.dataset.to);
      const start = elem.dataset.start ? elem.dataset.start : "top bottom";
      const end = elem.dataset.end ? elem.dataset.end : "bottom top";

      let tl = gsap.timeline({
        scrollTrigger: {
           trigger: elem,
           scrub: true,
           start: start,
           end: end,
        }
      });

      // const vars = Object.assign(from, stObj);
      tl.fromTo(elem, from, to)
    });
  },

  // mobile
  "(max-width: 1024px)": function() {
    gsap.utils.toArray('[data-mobile-from]').forEach((elem, i) => {
      const from = JSON.parse(elem.dataset.mobileFrom);
      const to = JSON.parse(elem.dataset.mobileTo);
      const start = elem.dataset.start ? elem.dataset.start : "top bottom";
      const end = elem.dataset.end ? elem.dataset.end : "bottom top";

      let tl = gsap.timeline({
        scrollTrigger: {
           trigger: elem,
           scrub: true,
           start: start,
           end: end,
        }
      });

      // const vars = Object.assign(from, stObj);
      tl.fromTo(elem, from, to)
    });
  }

});

$('body').on('click', '.js-product-card-color-swatch', function () {
  const swatchColor = $(this).attr('data-swatch-color');
  const $productCard = $(this).closest('.js-product-card');
  const newImageSrc = $productCard.find('.js-all-image-sources').attr('data-' + swatchColor);
  $productCard.find('.js-featured-image').attr('src', newImageSrc);
  $productCard.find('.js-featured-image').attr('srcset', '');
  $(this).closest('.collection-swatches').find('.active').removeClass('active');
  $(this).find('.collection-swatches__swatch').addClass('active');


});



ScrollTrigger.refresh();



});



$(document).ready(function(){
  setTimeout(function(){
    $('img').each(function(){
      if($(this).attr('alt_org')){
        $(this).attr('alt', $(this).attr('alt_org'));
      }
    });
  }, 1000);
});